import { User } from './../models/common/user'
import { Injectable } from '@angular/core'
import { apiUrl } from '../config/api-url'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  public trial$ = new BehaviorSubject<boolean>(false)

  private iss = {
    login: `${apiUrl}/auth/login`,
    register: `${apiUrl}/auth/register`,
    refresh: `${apiUrl}/auth/refresh`,
    loginAsDealer: `${apiUrl}/auth/login-as-dealer`,
    loginAsVendorUser: `${apiUrl}/auth/login-as-vendor-user`,
  }

  timeout: any = null

  private _roles = {
    sales: 'zWaiOjRrEmloPBdao',
    showroom_admin: 'SqpUkNldieDhdi',
    superadmin: 'tPolIkEdvnQacvjKu',
    vendor_user: 'aijfsvl2j4lkrjdl',
    vendor_admin: 'iikflkra488ldzzz',
  }

  constructor() {
    this.changeTrial(localStorage.getItem('trial') === 'yes')
  }

  public get user(): User {
    const user = localStorage.getItem('user')
    if (!user) return new User()
    return JSON.parse(user)
  }

  changeTrial(trial: boolean): void {
    this.trial$.next(trial)
    localStorage.setItem('trial', trial ? 'yes' : 'no')
  }

  handle(payload) {
    // TODO: encode user
    localStorage.setItem('user', JSON.stringify(payload.user))
    localStorage.setItem('token', payload.access_token)
    localStorage.setItem(
      'locale',
      JSON.stringify(payload.roles.map((role) => this._roles[role]))
    )
    const trial = payload.user.trial ? 'yes' : 'no'
    localStorage.setItem('trial', trial)
    this.changeTrial(trial == 'yes')
  }

  clear() {
    localStorage.removeItem('token')
    localStorage.removeItem('roles')
    localStorage.removeItem('trial')
  }

  get() {
    return localStorage.getItem('token')
  }

  getRoles() {
    let roles = localStorage.getItem('locale')
    if (!roles) return []
    const encoded = JSON.parse(roles)[0]
    for (let key in this._roles) {
      if (encoded == this._roles[key]) {
        return [key]
      }
    }
  }

  isValid() {
    const token = this.get()
    if (token) {
      const payload = this.payload(token)
      const isValid =
        Object.values(this.iss).indexOf(payload.iss) > -1 &&
        Math.floor(Date.now() / 1000) < payload.exp

      return isValid
    }
    return false
  }

  expiresIn() {
    const payload = this.payload(this.get())
    if (!payload) return -1
    const expiresIn = payload.exp - Math.floor(Date.now() / 1000)
    return expiresIn
  }

  loggedIn() {
    return this.isValid()
  }

  payload(token) {
    if (!token) return null
    const payload = token.split('.')[1]
    return this.decode(payload)
  }

  decode(payload) {
    return JSON.parse(atob(payload))
  }
}
